import { defineStore } from 'pinia'
import { store } from '../index'
// UserType
import { UserLoginType } from '@/api/login/types'
import { ElMessageBox } from 'element-plus'
import { useI18n } from '@/hooks/web/useI18n'
import { loginOutApi } from '@/api/login'
import { useTagsViewStore } from './tagsView'
import router from '@/router'
import { SUCCESS_CODE } from '@/constants'
import { getUnreadNoticeCountApi } from '@/api/notice'
import { getInfoApi } from '@/api/login'

interface UserState {
  userInfo?: any
  tokenKey: string
  token: string
  roleRouters?: string[] | AppCustomRouteRecordRaw[]
  rememberMe: boolean
  loginInfo?: UserLoginType
  unMessageCount: number
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      token: '',
      roleRouters: undefined,
      // 记住我
      rememberMe: true,
      loginInfo: undefined,
      unMessageCount: 0 // 未读消息数量
    }
  },
  getters: {
    getTokenKey(): string {
      return this.tokenKey
    },
    getToken(): string {
      return this.token
    },
    getUserInfo(): any | undefined {
      return this.userInfo
    },
    getRoleRouters(): string[] | AppCustomRouteRecordRaw[] | undefined {
      return this.roleRouters
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo
    },
    getUnMessageCount(): number {
      return this.unMessageCount
    }
  },
  actions: {
    setTokenKey(tokenKey: string) {
      this.tokenKey = tokenKey
    },
    setToken(token: string) {
      this.token = token
    },
    async setUserInfo() {
      const res = await getInfoApi()
      if (res?.code === SUCCESS_CODE) {
        this.userInfo = res
      }
    },
    setRoleRouters(roleRouters: string[] | AppCustomRouteRecordRaw[]) {
      this.roleRouters = roleRouters
    },
    logoutConfirm() {
      const { t } = useI18n()
      ElMessageBox.confirm(t('common.loginOutMessage'), t('common.reminder'), {
        confirmButtonText: t('common.ok'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      })
        .then(async () => {
          const res = await loginOutApi()
          if (res.code === SUCCESS_CODE) {
            this.reset()
          }
        })
        .catch(() => {})
    },
    reset() {
      this.setToken('')
      this.userInfo = undefined
      this.setRoleRouters([])
      const tagsViewStore = useTagsViewStore()
      tagsViewStore.delAllViews()
      router.replace('/login')
    },
    logout() {
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo
    },
    setUnMessageCount() {
      getUnreadNoticeCountApi().then((res) => {
        this.unMessageCount = res.data?.unreadNum || 0
      })
    }
  },
  persist: true
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
